<div class="grid-x">
  <div class="cell small-3 tiny-padding-all">
    {{ fixNameCasing(propertyMap.propertyName) }}
    @if (isPrimitive(propertyMap)) {
      <span>({{getPropertyType(propertyMap.propertyType)}})</span>
    }
    @if (!isPrimitive(propertyMap)) {
      <div class="grid-x minor-margin-top">
        <div class="cell small-6">
          <label for="propertyMap.propertyName">
            Map whole Node?
          </label>
        </div>
        <div class=" cell small-6">
          <input type="checkbox" id="propertyMap.propertyName" [(ngModel)]="propertyMap.mapWholeNode" />
        </div>
      </div>
    }
  </div>
  <div class="cell small-9">
    @if (propertyMap.isPrimitive) {
      <div class="input-group">
        <input type="text" class="no-margin" [(ngModel)]="propertyMap.contextPath" [disabled]="isRelationalProperty(propertyMap)" />
        <div class="input-group-button">
          <button (click)="pasteContext(propertyMap.propertyName)" attr.aria-label="Paste Value Into {{entityName}}">
            <span class="show-for-sr">Paste Value Into {{entityName}}</span>
            <svg-icon icon="icon-reply" class="tiny medium-gray" aria-hidden="true"></svg-icon>
          </button>
        </div>
      </div>
    }

    <div [ngClass]="{'hide': !propertyMap.mapWholeNode}">
      <input type="text" class="no-margin" [(ngModel)]="propertyMap.contextPath" />
      <div class="input-group-button">
        <button (click)="pasteContext(propertyMap.propertyName)" attr.aria-label="Paste Value Into {{entityName}}">
          <span class="show-for-sr">Paste Value Into {{entityName}}</span>
          <svg-icon icon="icon-reply" class="tiny medium-gray" aria-hidden="true"></svg-icon>
        </button>
      </div>
    </div>

    <div [ngClass]="{'hide': isPrimitive(propertyMap) || propertyMap.mapWholeNode}">
      <ng-container #objMap></ng-container>
    </div>
  </div>
</div>

<ng-template #submap>
  @if (!propertyMap.mapWholeNode) {
    <div>
      @for (subMap of propertyMap.propertyType; track subMap) {
        <div>
          <workflow-entity-map [entityMap]="entityMap" [propertyMap]="subMap" [entityName]="entityName" [template]="template" class="full-width" [contextValue]="contextValue"></workflow-entity-map>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #arrayMap>
  <div class="cell small-12 text-align-right">
    <input class="show-for-sr" type="checkbox" [attr.id]="propertyMap.propertyName" [(ngModel)]="useFunction" />
    <label aria-hidden="true" [attr.for]="propertyMap.propertyName" class="inline">
      <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
      <span class="control-label-text">Use Function for {{fixNameCasing(propertyMap.propertyName)}}</span>
    </label>
  </div>
  @if (useFunction) {
    <div class="cell small-3">
      Function to build {{fixNameCasing(propertyMap.propertyName)}}
    </div>
    <div class="cell small-9">
      <input type="text" class="no-margin" [(ngModel)]="propertyMap.contextPath" />
    </div>
  }
  @if (!useFunction) {
    <div class="cell small-12 text-align-right">
      <span aria-hidden="true">Add item to array {{fixNameCasing(propertyMap.propertyName)}}&nbsp;</span>
      <button (click)="addNode(propertyMap.propertyType)" attr.aria-label="Add item to array {{fixNameCasing(propertyMap.propertyName)}}">
        <span class="show-for-sr">Add item to array {{fixNameCasing(propertyMap.propertyName)}}</span>
        <svg-icon icon="icon-plus" class="tiny medium-gray" aria-hidden="true"></svg-icon>
      </button>
    </div>
    <div>
      <div class="grid-x">
        <div class="cell small-3 tiny-padding-all">
          {{ getPropertyType(propertyMap.propertyType)}}
        </div>
        @if (isPrimitive(propertyMap.propertyType)) {
          <div class="cell small-9">
            @for (map of propertyMap.propertyType; track map) {
              <div class="array-object">
                <workflow-entity-map [propertyMap]="map" [entityName]="entityName" [template]="template" class="full-width" [contextValue]="contextValue"></workflow-entity-map>
              </div>
            }
          </div>
        }
        @if (!isPrimitive(propertyMap.propertyType)) {
          <div class="cell small-9">
            @for (map of propertyMap.propertyType; track map) {
              <div class="array-object">
                <workflow-entity-map [entityMap]="entityMap" [propertyMap]="map" [entityName]="entityName" [template]="template" class="full-width" [contextValue]="contextValue"></workflow-entity-map>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

</ng-template>
<!-- TODO: Put something in here to be able to set the 'Can be array' property on the maps when this interface is revamped -->

